import React from "react";
import { Link } from "react-router-dom";
import { Mail, Phone, MapPin, Facebook, Instagram, Youtube } from "lucide-react";
import { NAV_LINKS, CONTACT_INFO } from "../mock/mock";

const Footer = () => {
  return (
    <footer className="relative z-[2] bg-[#0a0806] border-t border-[#e0b04c]/12 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-5">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <span className="font-serif-display text-3xl font-bold text-gold-gradient">
              A.T.O.M.
            </span>
            <p className="text-[#8f8577] text-sm mt-3 leading-relaxed">
              A Tribute to Frankie Beverly &amp; Maze. Faithfully honoring the
              music, the spirit, and the timeless joy.
            </p>
            <div className="flex gap-3 mt-5">
              {[
                { icon: Facebook, href: CONTACT_INFO.facebook },
                { icon: Instagram, href: "#" },
                { icon: Youtube, href: "#" },
              ].map(({ icon: Icon, href }, i) => (
                <a
                  key={i}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full border border-[#e0b04c]/25 flex items-center justify-center text-[#c9bda9] hover:bg-[#e0b04c] hover:text-[#0c0a08] hover:border-[#e0b04c] transition-all duration-300"
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h4 className="text-[#e0b04c] font-semibold text-sm uppercase tracking-wider mb-4">
              Explore
            </h4>
            <ul className="space-y-2.5">
              {NAV_LINKS.map((l) => (
                <li key={l.path}>
                  <Link
                    to={l.path}
                    className="text-[#a89e8c] text-sm hover:text-[#e0b04c] transition-colors"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-[#e0b04c] font-semibold text-sm uppercase tracking-wider mb-4">
              Contact
            </h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-center gap-3 text-[#a89e8c]">
                <Mail size={16} className="text-[#e0b04c]" />
                {CONTACT_INFO.email}
              </li>
              {CONTACT_INFO.phones.map((p) => (
                <li key={p} className="flex items-center gap-3 text-[#a89e8c]">
                  <Phone size={16} className="text-[#e0b04c]" />
                  {p}
                </li>
              ))}
              <li className="flex items-center gap-3 text-[#a89e8c]">
                <MapPin size={16} className="text-[#e0b04c]" />
                {CONTACT_INFO.location}
              </li>
            </ul>
          </div>

          {/* CTA */}
          <div>
            <h4 className="text-[#e0b04c] font-semibold text-sm uppercase tracking-wider mb-4">
              Book The Band
            </h4>
            <p className="text-[#a89e8c] text-sm mb-4 leading-relaxed">
              Bring the magic of Maze to your next event.
            </p>
            <Link
              to="/booking"
              className="inline-flex bg-gradient-to-b from-[#e8bc55] to-[#c99339] text-[#0c0a08] font-semibold text-sm px-6 py-3 rounded-md hover:-translate-y-0.5 hover:shadow-[0_8px_30px_rgba(224,176,76,0.35)] transition-all duration-300"
            >
              Request Availability
            </Link>
          </div>
        </div>

        <div className="border-t border-white/5 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-[#6f6656] text-xs">
            &copy; {new Date().getFullYear()} A.T.O.M. – A Tribute to Frankie Beverly &amp; Maze. All rights reserved.
          </p>
          <p className="text-[#6f6656] text-xs">
            Made with soul &bull; Washington DC – Nationwide
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
